module.exports = __webpack_public_path__ + "img/puzzle.4b129ac3.svg";